<template>
  <div v-if="currentOf">
    <div class="row">
      <div class="col-lg-6">
        <BreadCrumd :title="'OFs'" :description="'Aperçu d\'un OF'" />
      </div>
      <div class="col-lg-6 mt-lg-4" v-if="currentOf.document">
        <div class="row" v-if="currentOf.produit">
          <div class="col-md-12">
            <table
              class="card table table-sm table-custom-primary table-bordered mb-0"
            >
              <tbody>
                <tr class="d-flex">
                  <td class="col-12 text-center font-weight-bold">
                    Produit concerné
                  </td>
                </tr>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-8 text-custom-primary">
                    Désignation : {{ currentOf.produit.designation }}
                  </td>
                  <td class="col-4 text-custom-primary">
                    Référence : {{ currentOf.produit.reference }}
                  </td>
                </tr>
                <tr class="d-flex">
                  <td class="col-6 font-weight-bold">
                    Type : {{ currentOf.produit.type }}
                  </td>
                  <td class="col-6 font-weight-bold">
                    Stock :
                    {{
                      currentOf.produit.stock + ' ' + currentOf.produit.unite
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row" v-if="currentOf.document">
          <div class="col-md-12">
            <table
              class="card table table-sm table-custom-primary table-bordered mb-0"
            >
              <tbody>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-6 text-custom-primary">
                    Référence OF : {{ currentOf.document.reference }}
                  </td>
                  <td class="col-6">
                    Statut :
                    <i
                      :class="[
                        {
                          'text-warning': currentOf.statut === CONST.ATTENTE,
                          'text-success':
                            currentOf.statut === CONST.ENCOURS ||
                            currentOf.statut === CONST.TERMINER,
                          'text-danger': currentOf.statut === CONST.ARRETER,
                        },
                        edit.MDI_CHECKBOX_CIRCLE,
                        'mr-1',
                      ]"
                    ></i>
                    {{ getStatutOF(currentOf.statut) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12 col-lg-6">
        <button
          type="button"
          class="btn btn-secondary mr-4"
          @click.prevent="$router.push({ name: 'gpao_of' }).catch(() => {})"
        >
          Liste des OFs
        </button>
        <button
          type="button"
          class="btn btn-custom-primary mr-4"
          @click.prevent="
            $router.push({ name: 'gpao_of-create' }).catch(() => {})
          "
        >
          <i :class="edit.ICON_PLUS"></i>
          Nouvel OF
        </button>

        <button
          type="button"
          class="btn btn-custom-primary"
          @click.prevent="
            $router
              .push({
                name: 'gpao_of-show',
                params: { id: currentOf.id },
              })
              .catch(() => {})
          "
        >
          <i :class="edit.ICON_EYE" class="font-size-17"></i> Aperçu
        </button>
      </div>
      <div class="col-md-12 col-lg-6">
        <b-button
          variant="success"
          class="btn-icon mr-4"
          v-if="currentOf.statut === CONST.ATTENTE"
          @click="demarrer"
        >
          <span class="btn-icon-label">
            <i :class="edit.ICON_PLAY"></i>
          </span>
          Démarrer
        </b-button>

        <b-button
          variant="success"
          class="btn-icon mr-4"
          v-if="currentOf.statut === CONST.ARRETER"
          @click="redemarrer"
        >
          <span class="btn-icon-label">
            <i class="fas fa-play"></i>
          </span>
          Redémarrer
        </b-button>

        <b-button
          variant="success"
          class="btn-icon mr-4"
          v-if="currentOf.statut === CONST.ENCOURS"
          @click="terminer"
        >
          <span class="btn-icon-label">
            <i :class="edit.ICON_THUMBS_UP"></i>
          </span>
          Terminer
        </b-button>

        <b-button
          variant="danger"
          class="btn-icon mr-4"
          v-if="currentOf.statut === CONST.ENCOURS"
          @click="arreter"
        >
          <span class="btn-icon-label">
            <i :class="edit.ICON_STOP"></i>
          </span>
          Arrêter
        </b-button>

        <b-button
          variant="warning"
          class="btn-icon"
          v-if="currentOf.statut !== CONST.ATTENTE"
          @click="reinitialiser"
        >
          <span class="btn-icon-label">
            <i :class="edit.ICON_HOURGLASS"></i>
          </span>
          Mettre en attente
        </b-button>
      </div>
    </div>

    <div class="mt-4 mt-lg-4 mb-4">
      <div class="row">
        <div class="col-md-12">
          <b-nav tabs>
            <b-nav-item
              :to="{ name: 'gpao_of-edit', params: { id: currentOf.id } }"
              exact
              exact-active-class="active"
              ><i
                :class="edit.ICON_EDIT"
                class="text-custom-primary font-size-17"
              ></i>
              OF
            </b-nav-item>
            <b-nav-item
              :to="{
                name: 'gpao_of_edit-document',
                params: {
                  id: currentOf.id,
                  documentUuid: currentOf.document.uuid,
                },
              }"
              exact
              exact-active-class="active"
              ><i
                :class="edit.ICON_PAPERCLIP"
                class="text-custom-primary font-size-17"
              ></i>
              Documents</b-nav-item
            >

            <b-nav-item
              :to="{
                name: 'gpao_of_edit_consommation',
                params: {
                  id: currentOf.id,
                },
              }"
              ><i
                :class="edit.ION_CUBE"
                class="text-custom-primary font-size-17"
              ></i>
              Consommations</b-nav-item
            >

            <b-nav-item
              :to="{
                name: 'gpao_of_edit_production',
                params: {
                  id: currentOf.id,
                },
              }"
              ><i
                :class="edit.ION_CUBE"
                class="text-custom-primary font-size-17"
              ></i>
              Productions</b-nav-item
            >

            <b-nav-item
              :to="{
                name: 'gpao_of_edit_operateur',
                params: {
                  id: currentOf.id,
                },
              }"
              ><i
                :class="edit.ICON_CLOCK"
                class="text-custom-primary font-size-17"
              ></i>
              Temps opérateur</b-nav-item
            >

            <b-nav-item
              :to="{
                name: 'gpao_of_edit_reporting',
                params: {
                  id: currentOf.id,
                },
              }"
              ><i
                :class="show.ION_DASHBOARD"
                class="text-custom-primary font-size-17"
              ></i>
              Reporting OF</b-nav-item
            >
          </b-nav>
        </div>
      </div>

      <div>
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import URL from '@/http/gpao/of';
import { edit } from '@/icons/gpao/of';
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
import CONST from '@/constants/gpao/of';

export default {
  data() {
    return {
      edit,
      id: this.$route.params.id,
      title: 'Gestion des OFs - Edition',
      CONST,
    };
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  computed: {
    ...mapGetters('of', ['currentOf']),
  },
  methods: {
    onChangeStatut() {
      this.$router
        .push({
          name: 'gpao_of-show',
          params: { id: this.currentOf.id },
        })
        .catch(() => {});
    },
    ...mapActions('of', ['setCurrentOf', 'setPriorites']),
    reinitialiser() {
      this.showConfirmValidation().then((result) => {
        if (result.value) {
          window.axios
            .put(URL.REINITIALISER + '/' + this.id)
            .then((resp) => {
              this.showSimpleAlerte('top-end', 'success', resp.data.message);
              this.onChangeStatut();
            })
            .catch();
        }
      });
    },
    demarrer() {
      this.showConfirmValidation().then((result) => {
        if (result.value) {
          window.axios
            .put(URL.DEMARRER + '/' + this.id)
            .then((resp) => {
              this.showSimpleAlerte('top-end', 'success', resp.data.message);
              this.onChangeStatut();
            })
            .catch();
        }
      });
    },
    arreter() {
      this.showConfirmValidation().then((result) => {
        if (result.value) {
          window.axios
            .put(URL.ARRETER + '/' + this.id)
            .then((resp) => {
              this.showSimpleAlerte('top-end', 'success', resp.data.message);
              this.onChangeStatut();
            })
            .catch();
        }
      });
    },
    terminer() {
      this.showConfirmValidation().then((result) => {
        if (result.value) {
          window.axios
            .put(URL.TERMINER + '/' + this.id)
            .then((resp) => {
              this.showSimpleAlerte('top-end', 'success', resp.data.message);
              this.onChangeStatut();
            })
            .catch();
        }
      });
    },
    redemarrer() {
      this.showConfirmValidation().then((result) => {
        if (result.value) {
          window.axios
            .put(URL.REDEMARRER + '/' + this.id)
            .then((resp) => {
              this.showSimpleAlerte('top-end', 'success', resp.data.message);
              this.onChangeStatut();
            })
            .catch();
        }
      });
    },
    init() {
      this.setCurrentOf(null);
      this.setPriorites([]);

      window.axios
        .all([
          window.axios.get(URL.OF + '/' + this.$route.params.id, {
            params: { edit: true },
          }),
          window.axios.get(URL.GET_REQUIREMENTS),
        ])
        .then(
          window.axios.spread((resp1, resp2) => {
            this.setCurrentOf(resp1.data.of);
            this.setPriorites(resp2.data.priorites);
          })
        )
        .catch();
    },
  },
  mounted() {
    this.init();
  },
};
</script>
